// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__j6RIa","colMaxWidth":"Table_colMaxWidth__3h_NT"};